//  Services
import { AmssService } from './amss.service';
import { Injectable, EventEmitter } from '@angular/core';
import 'rxjs/add/operator/map'

@Injectable()
export class RegistrationService extends AmssService {
    signUp(user: any) {
        return this.getHttpService()
            .POST(`${this.apiUrl}/${this.year}/register`, 'application/json', user, false)
            .map(response => response.json());
    }
    restorePassword(user: any) {
        return this.getHttpService()
            .POST(`${this.apiUrl}/${this.year}/restore`, 'application/json', user, false)
            .map(response => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/services/registration.service.ts